import React from 'react';
import loadingImageLight from '../assets/Valentines2023/Landing/GLAMPARK_LANDINGPAGE_VDAY_02_on.jpg'
import loadingImageDark from '../assets/Valentines2023/Landing/GLAMPARK_LANDINGPAGE_VDAY_02_off.jpg'
//import loadingLight from '../assets/Images/LOADING/Landing_Image_Flash_on-min.jpg'
//import loadingDark from '../assets/Images/LOADING/Landing_Image_Flash_off-min.jpg'
import desktopImageA from '../assets/Images/GLAMPARK_1178x736_OPTION_02_OFF_b.png'
import desktopImageB from '../assets/Images/GLAMPARK_1178x736_OPTION_02_ON_b.png'
import loadingPipsA from '../assets/Valentines2023/Landing/Loading_a_w.png'
import loadingPipsB from '../assets/Valentines2023/Landing/Loading_b_w.png'
import loadingPipsC from '../assets/Valentines2023/Landing/Loading_c_w.png'
import loadingPipsD from '../assets/Valentines2023/Landing/Loading_d_w.png'
import QRCode from "react-qr-code";

const loadingPips = [loadingPipsA,
                     loadingPipsB,
                     loadingPipsC,
                     loadingPipsD]

const {useState, useEffect, useRef} = React

export function LandscapeMode(props) {

  const [darkCounter, setDarkCounter] = useState(0)
  const timerSet = useRef(false);
  
  useEffect(() => {

    if (!timerSet.current) {
        setInterval(() => {       
          setDarkCounter (prev => prev + 1)
        }, 100)
      timerSet.current = true;
    }
  }, []);

  const darkCyclePos = darkCounter % 15
  const light = (darkCyclePos === 11 || darkCyclePos === 13)

  var lightStyle
  var darkStyle
  if (light) {
    lightStyle = {display: "block"}
    darkStyle = {display: "none"}
  }
  else {
    lightStyle = {display: "none"}
    darkStyle = {display: "block"}
  }

  return (
    <div className='errorBackground'>
      <div className='errorWrapper'>
        <img alt="" className='errorImage' style = {lightStyle} src={desktopImageA}/>
        <img alt="" className='errorImage' style = {darkStyle} src={desktopImageB}/>
        {props.url ?
          <div className="qrWrapper">
                  <div className="qrWrapperInner">
                      <QRCode value={props.url} fgColor="#000" bgColor="#e7c6ce" size={200} />
                  </div>
          </div> : 
          <>
          </>
        }
      </div>
    </div>
  )
}

export function LoadingScreen(props) {

  const [darkCounter, setDarkCounter] = useState(0)
  const timerSet = useRef(false);
  const imagesLoaded = useRef(0);

  useEffect(() => {

    // After 1 second, alternate dark/light every 100msecs.
    if (!timerSet.current) {
        setInterval(() => {       
          setDarkCounter (prev => prev + 1)
        }, 100)
      timerSet.current = true;
    }
  }, []);

  let loadingWrapperClass
  if (props.ready) {
    loadingWrapperClass = 'loadingWrapper'
  }
  else {
    loadingWrapperClass = 'loadingWrapperNotReady'
  }

  function imageLoaded() {

    imagesLoaded.current++;
    if (imagesLoaded.current >= 2) {
      props.readyCallback()
    }
  }

  const darkCyclePos = darkCounter % 15
  const pips = (Math.floor(darkCounter / 5)) % 4
  const light = (darkCyclePos === 11 || darkCyclePos === 13)

  var lightStyle
  var darkStyle
  if (light) {
    lightStyle = {display: "block"}
    darkStyle = {display: "none"}
  }
  else {
    lightStyle = {display: "none"}
    darkStyle = {display: "block"}
  }

  return (
    <div className={loadingWrapperClass}>      
      <div className='loadingWrapperTopBottom'>
        <img alt="" className='loadingImageXmas' src={loadingImageDark} style = {darkStyle}
        onLoad={() => imageLoaded()}/>
        <img alt="" className='loadingImageXmas' src={loadingImageLight} style = {lightStyle}
        onLoad={() => imageLoaded()}/>
      </div>
      <div className='loadingPipsXmasWrapper'>
        <img alt="" className='loadingPipsXmas'
          src={loadingPips[pips]}>
        </img>
      </div>

      {/*<div className='loadingWrapperCenter'>
        <img alt="" className='loadingImage' src={loadingDark} style = {darkStyle}
        onLoad={() => imageLoaded()}/>
        <img alt="" className='loadingImage' src={loadingLight} style = {lightStyle}
        onLoad={() => imageLoaded()}/>
        </div>*/}
    </div>
    
  )
}
